/**
 * ClawInstall landing (`/`) — eager half of the route. Registers the file route
 * with its SSR head only; the page component and every design / seam / atom
 * import live in `index.lazy.tsx` so they load with this route and never land in
 * the always-loaded `main` chunk (the `entryChunkGzipKb` budget, CLA-645).
 * Mounted outside the `/clawinstall` layout (trailing-underscore escape) so the
 * design frame's `<main>` is the page's only main landmark.
 *
 * Replaces the token landing (`routes/clawinstall/index.tsx`): the visible
 * markup now comes entirely from the phase-1 `PublicHome` / `PublicHomeMobile`
 * design components, wired through the public-pages seam in the lazy half.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { identityFromHeadCtx, publicPageHead } from "~/lib/clawinstall-marketing-head.ts";

/** SSR head for `/`: identity-scoped title/canonical, managed-agent description. @since 1.0.0 */
export const homeHead = (ctx?: Parameters<typeof identityFromHeadCtx>[0]) => {
  const identity = identityFromHeadCtx(ctx);
  return publicPageHead({
    path: "/",
    title: `${identity.displayName} — Your business's own AI agent`,
    description:
      "A private OpenClaw agent for your business, installed, locked down and kept running. Connected to Slack, WhatsApp, Google Workspace and the tools your team already uses.",
    identity,
  });
};

export const Route = createFileRoute("/clawinstall_/")({
  head: homeHead,
});
